angular.module('nv.support-attendance-form').controller('SupportAttendanceFormCtrl', SupportAttendanceFormCtrl);

function SupportAttendanceFormCtrl(
  $state,
  $stateParams,
  $timeout,
  AttendanceRecord,
  attendanceRecords,
  BackgroundJobSpinner,
  currentSchool,
  currentUser,
  ErrorModal,
  SpinnerModal,
  studentSupports,
  support,
  SupportAttendanceService,
  UtilitiesService,
) {
  /**
   * For each studentSupport aligned to this support, create an
   * attendance roster item aligned to view requirements
   */
  this._buildNewAttendanceRoster = function(studentSupports, iso) {
    return studentSupports.reduce((result, studentSupport) => {
      if (studentSupport.isDeleted()) return result;
      const hasStarted = studentSupport.startsOn <= iso;
      const hasCompleted = studentSupport.completedAt > iso || !studentSupport.completedAt;
      if (hasStarted && !hasCompleted) return result;
      result.push({
        _id: UtilitiesService.createV4Uuid(),
        status: 'PRESENT',
        studentSupportStatus: studentSupport.status,
        student: studentSupport.student,
        startsOn: studentSupport.startsOn.substr(0, 10),
        completedAt: studentSupport.completedAt,
        deletedAt: studentSupport.deletedAt,
        studentSupportId: studentSupport._id,
      });
      return result;
    }, []);
  };
  /**
   * Re-create a roster of students from the submitted attendance records with that event date
   */
  this._buildAttendanceRosterFromExisting = function(attendanceRecords, studentSupports) {
    return attendanceRecords.map(record => {
      const foundStudentSupport = studentSupports.find(studentSupport => {
        return studentSupport.student.studentId === record.studentId;
      });
      return {
        _id: record._id,
        status: record.status,
        studentSupportStatus: foundStudentSupport.status,
        student: foundStudentSupport.student,
        startsOn: foundStudentSupport.startsOn.substr(0, 10),
        completedAt: foundStudentSupport.completedAt,
        deletedAt: foundStudentSupport.deletedAt,
      };
    });
  };
  /**
   * Filters a roster of students by the date they started the support.
   */
  this.filterRosterByStudentStartsOnDate = function(roster, iso) {
    return _.filter(roster, (item: any) => {
      return item.startsOn <= iso;
    });
  };
  /**
   * When in edit mode, filter students supports to only those that align
   * to a provided set of attendance records.
   */
  this._filterStudentSupportsByAttendanceRecords = function(studentSupports, attendanceRecords) {
    return attendanceRecords.map(record => {
      return studentSupports.find(studentSupport => studentSupport.student.studentId === record.studentId);
    });
  };
  /**
   * Filter all possible attendance dates for those that have not yet been logged
   * Return array of date items with loggedAt values
   */
  this._getUnloggedEventDates = (rawAttendanceDates, attendanceRecords) => {
    return rawAttendanceDates.reduce(function filterForUnLoggedDates(a, date) {
      const iso = date.format('YYYY-MM-DD');
      const foundLog = _.find(attendanceRecords, { eventDate: iso });
      if (!foundLog) {
        const human = date.format('MM/DD/YYYY (dddd)');
        a.push({ iso, human });
      }
      return a;
    }, []);
  };

  this._formatEventDate = eventDateIso => {
    const human = moment(eventDateIso).format('MM/DD/YYYY (dddd)');
    const iso = eventDateIso;
    return { iso, human };
  };
  /**
   * Creates the expected payload for attendanceRecords/bulk/create
   * TODO: should this be moved to the AttendanceRecord.model.js file???
   */
  this._buildBulkCreatePayload = function(_eventDate, rosterItems) {
    // The fields that will be same for all patches
    const schoolId = currentSchool._id;
    const supportId = support._id;
    const eventDate = _eventDate.iso;

    // creates an object with {<studentId>: <UUID>} for record with matching status
    function hashStudentIds(rosterItems, status) {
      return rosterItems.reduce((a, rosterItem) => {
        if (rosterItem.status === status) {
          a[rosterItem.student.studentId] = {
            attendanceRecordId: UtilitiesService.createV4Uuid(),
            studentSupportId: rosterItem.studentSupportId,
          };
        }
        return a;
      }, {});
    }

    // Create a patch item for each status value
    const patches = ['ABSENT', 'PRESENT', 'LATE'].map(function buildPatchItem(status) {
      return {
        studentIds: hashStudentIds(rosterItems, status),
        attendanceRecord: {
          schoolId,
          supportId,
          eventDate,
          status,
        },
      };
    });
    return { patches };
  };
  /**
   * Creates the expected payload for attendanceRecords/bulk/update
   * TODO: should this be moved to the AttendanceRecord.model.js file???
   *    {
   *      patches: [
   *        { attendanceRecordIds: [], patch {} }
   *      ]
   *    }
   */
  this._buildBulkEditPayload = function(rosterItems) {
    function filterRecordIds(rosterItems, status) {
      return rosterItems.reduce((a, item) => {
        if (item.hasChanged && item.status === status) {
          a.push(item._id);
        }
        return a;
      }, []);
    }

    // Create a patch item for each status value
    const patches = ['ABSENT', 'PRESENT', 'LATE']
      .map(function buildPatchItem(status) {
        return {
          attendanceRecordIds: filterRecordIds(rosterItems, status),
          patch: { status },
        };
      })
      .filter(function filterOutEmpties(patch) {
        return patch.attendanceRecordIds.length > 0;
      });
    return { patches };
  };
  /**
   * Sums all attendance records that match provided status
   */
  this.sumByStatus = status => {
    return _.sumBy(this.attendanceRoster, function sumPresentVals(rosterItem: any) {
      return rosterItem.status === status ? 1 : 0;
    });
  };
  /**
   * When user clicks "Mark all as PRESENT" or "... ABSENT" apply to all attendance records
   */
  this.updateStatusForAllStudents = status => {
    this.attendanceRoster.map(function patchStatusField(rosterItem) {
      rosterItem.status = status;
      rosterItem.hasChanged = true;
    });
  };
  /**
   * When user selects an event date, patch each attendance record
   */
  this.onDateSelect = eventDate => {
    this.attendanceRoster.map(function patchEventDateWithSelected(rosterItem) {
      rosterItem.eventDate = eventDate;
    });
  };
  /**
   * Submits an attendanceRecords/bulk/create request
   */
  this.onSubmit = (eventDate, rosterItems, isEditMode, isUnloggedMode) => {
    // create or update, depending on mode
    let backgroundJob;
    if (isEditMode && !isUnloggedMode) {
      const payload = this._buildBulkEditPayload(rosterItems);
      backgroundJob = AttendanceRecord.bulkUpdate(payload);
    } else {
      const payload = this._buildBulkCreatePayload(eventDate, rosterItems);
      backgroundJob = AttendanceRecord.bulkCreate(payload);
    }
    backgroundJob
      .then(function redirectingToOverview() {
        $state.go('main.school.support-overview', { supportId: support._id });
      })
      .catch(ErrorModal.show);
    const spinnerMsg = `Logging attendance students`;
    BackgroundJobSpinner.activateSpinner(spinnerMsg, backgroundJob);
  };

  this.cancel = () => {
    $state.go('main.school.support-overview', { supportId: this.support._id });
  };

  /**
   * Gets the proper value for the submit button
   */
  this.getButtonValue = function(isEditMode, isUnloggedMode) {
    if (isEditMode && isUnloggedMode) return 'SUBMIT ATTENDANCE';
    if (isEditMode && !isUnloggedMode) return 'RESUBMIT ATTENDANCE';
    return 'SUBMIT ATTENDANCE';
  };

  function _isEditMode(params) {
    return _.includes(['true', true], params.edit);
  }

  function _isUnloggedMode(params) {
    return _.includes(['true', true], params.isUnlogged);
  }
  /**
   * Sets all values needed for view on load
   */
  (function onInit() {
    this.support = support;
    this.currentSchool = currentSchool;
    this.currentUser = currentUser;

    // Assume NOT edit mode and NOT unlogged
    this.isEditMode = _isEditMode($stateParams);
    this.isUnloggedMode = _isUnloggedMode($stateParams);
    const eventDate = $stateParams.eventDate || null;

    let eventDatePickerOptions;
    let attendanceRoster;

    // 1) Load either a single event date, or multiple

    // if ?eventDate exists, make that date the only available option for picker
    if (eventDate) {
      this.eventDate = this._formatEventDate($stateParams.eventDate);
      eventDatePickerOptions = [this.eventDate];
    } else {
      // Otherwise load all unlogged dates
      const rawAttendanceDates = SupportAttendanceService.getAllAttendanceDates(support);
      eventDatePickerOptions = this._getUnloggedEventDates(rawAttendanceDates, attendanceRecords);
    }

    // 2) Load either the current roster or the roster that existed at the time of the log date

    if (this.isUnloggedMode) {
      // New log, get current roster of assigned students
      const unfiltered = this._buildNewAttendanceRoster(studentSupports, eventDate);
      // If an eventDate exists, filter by it
      attendanceRoster = eventDate ? this.filterRosterByStudentStartsOnDate(unfiltered, eventDate) : unfiltered;
    } else {
      // Otherwise get the roster of students from the logged records
      const filteredStudentSupports = this._filterStudentSupportsByAttendanceRecords(
        studentSupports,
        attendanceRecords,
      );
      attendanceRoster = this._buildAttendanceRosterFromExisting(attendanceRecords, filteredStudentSupports);
    }

    this.attendanceRoster = _.sortBy(attendanceRoster, 'student.lastFirst');
    // Reverse order of dates so most recent is first
    this.eventDatePickerOptions = eventDatePickerOptions.reverse();

    this.supportIsNotStarted = this.support.isNotStarted();

    SpinnerModal.deactivateSpinner();
  }.apply(this));
}
